import { wencesApi } from "@/api/wencesApi";

/**
 * Layout del dashboard de cada usuario (back: userDashboardLayoutController):
 * `{ widgets, activePresetId, presetDirty }`. `widgets: null` = nunca lo personalizó
 * (ni hay predeterminado del admin); el front arma el de fábrica.
 */
export async function fetchDashboardLayout({ fresh = false } = {}) {
  // `fresh`: wencesApi guarda los GET 2 s; después de borrar o aplicar hay que saltearla.
  const { data } = await wencesApi.get("/api/users/dashboard-layout", fresh ? { params: { _: Date.now() } } : undefined);
  const d = (data && data.data) || {};
  return { widgets: Array.isArray(d.widgets) ? d.widgets : null, activePresetId: d.activePresetId || null, presetDirty: !!d.presetDirty };
}

export async function saveDashboardLayout(widgets, { activePresetId = null, presetDirty = false } = {}) {
  const { data } = await wencesApi.put("/api/users/dashboard-layout", { widgets, activePresetId, presetDirty });
  return data && data.data ? data.data.widgets : widgets;
}

export async function fetchDashboardPresets() {
  const { data } = await wencesApi.get("/api/users/dashboards", { params: { _: Date.now() } });
  return (data && data.data) || [];
}

export async function resetDashboardLayout() {
  await wencesApi.delete("/api/users/dashboard-layout");
  return null;
}
